import { createFileRoute } from '@tanstack/react-router'
import AgreementsReportList from 'Royalty/components/Test/tabs/AgreementsReportList'

export const Route = createFileRoute('/royalty/reports/agreements')({
    component: AgreementsReportList,
})
